/*
 * @Author: Teemo Ding
 * @Date: 2021-08-18 13:42:13
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-25 11:24:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/ThirdPartyLoginAccount/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const ThirdPartyLoginAccount = ({ thirdPartyLoginAccounts }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.informationContainer} ${css.wrapperContainer}`}
        title={getI18n(
          'customerList.thirdPartyLoginAccount.thirdPartyLoginAccount',
        )}>
        <div>
          {(thirdPartyLoginAccounts || []).map((item, index) => (
            <div key={index} className={css.item}>
              <span>{item.thirdPartyProvider}</span>
              <span>{item.openId || '-'}</span>
            </div>
          ))}
        </div>
      </SectionWrapper>
    </div>
  );
};

export default ThirdPartyLoginAccount;
